import { render, staticRenderFns } from "./QRCodeViewer.vue?vue&type=template&id=a538f5ba&scoped=true"
import script from "./QRCodeViewer.vue?vue&type=script&lang=js"
export * from "./QRCodeViewer.vue?vue&type=script&lang=js"
import style0 from "./QRCodeViewer.vue?vue&type=style&index=0&id=a538f5ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a538f5ba",
  null
  
)

export default component.exports